/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Agents_Title_2Inputs */

const en_svc_agents_title_2 = /** @type {(inputs: Svc_Agents_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`that know where to stop.`)
};

const lv_svc_agents_title_2 = /** @type {(inputs: Svc_Agents_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kas zina, kur apstāties.`)
};

/**
* | output |
* | --- |
* | "that know where to stop." |
*
* @param {Svc_Agents_Title_2Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_agents_title_2 = /** @type {((inputs?: Svc_Agents_Title_2Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Agents_Title_2Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_agents_title_2(inputs)
	return en_svc_agents_title_2(inputs)
});